import { render } from "./PersonalDetailsPage.vue?vue&type=template&id=ac768578"
import script from "./PersonalDetailsPage.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__